import { render, staticRenderFns } from "./projectpersonnelSalary.vue?vue&type=template&id=cd05fba4&"
import script from "./projectpersonnelSalary.vue?vue&type=script&lang=js&"
export * from "./projectpersonnelSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports